import { useField } from "formik";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { useState } from "react";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import { MultiSelect } from "primereact/multiselect";
import TooltipPrime from "../PrimeComponents/TooltipPrime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export const PrimeSelect = ({ edit, nombre, dataValue, defaultText, campo, validate, error,
    options, optionKey, optionLabel, placeholder, onChange,tooltip, ...extraProps }) => {
    const [field, , { setValue }] = useField({ name: campo, validate });

    const hasOptions = Array.isArray(options) && options.length;
    if (!campo) return null;

    if (edit && hasOptions) return (
        <div className="row linea-formulario">
            <div className="col-12 col-md-6 text-md-right">
                <label className='boldie'>{nombre}</label>
            </div>
            <div className="mb-2 col-12 col-md-6 d-block">
                <Dropdown
                    className="mkt-dropdown"
                    panelClassName='mkt-dropdown-popup'
                    inputId={field.name}
                    placeholder={placeholder}
                    value={field.value}
                    options={options}
                    optionLabel={optionLabel ?? "label"}
                    optionValue={optionKey ?? "value"}
                    onChange={(e) => {setValue(e.value); onChange && onChange(e.value);}}
                    style={{ color: "#495057", width: "10vw" }}
                    filter
                    {...extraProps}
                />
                {tooltip?
                    <TooltipPrime id={`selectorTooltip_${field.name}`} content={tooltip} position="right">
                        <FontAwesomeIcon style={{ color: "#1E84A6", marginLeft:"1rem" }} icon={faInfoCircle} />
                    </TooltipPrime>
                    :null}
            </div>
            {error ?
                <div className="mb-2 col-12 d-block">
                    <div className="alert alert-warning m-0" role="alert">{nombre}: {error}</div>
                </div>
                : null}
        </div>
    );

    const dataToShow = edit ? field.value : dataValue;
    if (!dataToShow && !defaultText) return null;
    let selected = null;
    const thisOption = hasOptions && dataToShow && options.find((option) => option[optionKey] === dataToShow);
    if (thisOption) selected = thisOption[optionLabel] || "";

    return (
        <div className="row linea-formulario">
            <div className="col-12 col-md-6 text-md-right mtem-05">
                <label className='boldie'>{nombre}</label>
            </div>
            <div className="col-12 col-md-6 text-md-left mtem-05">
                <span>{selected || defaultText}</span>
            </div>
        </div>
    );
};

export const PrimeDatePicker = ({ edit, nombre, campo, validate, error,
    placeholder, minDate, maxDate, ...extraProps }) => {
    const [field, , { setTouched, setValue }] = useField({ name: campo, validate });

    if (!campo) return null;


    return (
        <div className="row linea-formulario">
            <div className="col-12 col-md-6 text-md-right">
                <label className='boldie'>{nombre}</label>
            </div>
            <div className="mb-2 col-12 col-md-6 d-block">
                <Calendar
                    value={field.value}
                    minDate={minDate}
                    maxDate={maxDate}
                    readOnlyInput
                    dateFormat="dd-MM-yy"
                    placeholder={placeholder}
                    disabled={!edit}
                    onChange={(e) => {setValue(e.value);}}
                    onHide={() => setTouched(true)}
                    {...extraProps}
                />
            </div>
            {error ?
                <div className="mb-2 col-12 d-block">
                    <div className="alert alert-warning m-0" role="alert">{nombre}: {error}</div>
                </div>
                : null}
        </div>
    );
};

export const PrimeCheckbox = ({ edit, nombre, campo, validate, error, placeholder }) =>  {
    const [field, , { setValue }] = useField({ name: campo, validate });
    return <div className="row linea-formulario">
        <Checkbox
            inputId={field.name}
            name={field.name}
            onChange={e => setValue(e.checked)}
            checked={field.value}
            disabled={!edit}
        />
        <label htmlFor={field.name} className="ml-2 mb-0">
            {placeholder}
        </label>
        {error ?
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{nombre}: {error}</div>
            </div>
            : null}
    </div>;
};

export const PrimeRadioGroup = ({ edit, nombre, campo, validate, error, radioBtns }) =>  {
    const [field, , { setValue }] = useField({ name: campo, validate });
    return <div className="row linea-formulario">
        <div className="col-12 col-md-6 text-md-right">
            <label className='boldie'>{nombre}</label>
        </div>
        <div className="mb-2 col-12 col-md-6 d-block d-flex flex-column">
            {radioBtns.map((btn, i) => {
                return (
                    <div className="d-flex align-items-center" key={i}>
                        <RadioButton
                            id={btn.id}
                            inputId={btn.id}
                            name={btn.id}
                            value={btn.value}
                            disabled={!edit}
                            checked={field.value === btn.value}
                            onChange={e => setValue(e.value)}
                        />
                        <label htmlFor={btn.id} className="ml-1 mb-0">
                            {btn.label}
                        </label>
                    </div>
                );
            })}
        </div>
        {error ?
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{nombre}: {error}</div>
            </div>
            : null}
    </div>;
};

export const PrimeTextArea = ({ edit, nombre, campo, validate, error, placeholder }) =>  {
    const [field, , { setValue }] = useField({ name: campo, validate });
    return <div className="row linea-formulario">
        <div className="col-12 col-md-6 text-md-right">
            <label className='boldie'>{nombre}</label>
        </div>
        <div className="mb-2 col-12 col-md-6 d-block d-flex flex-column">
            <InputTextarea
                disabled={!edit}
                style={{ fontSize: "12px", lineHeight: "normal" }}
                value={field.value}
                onChange={(e) => setValue(e.target.value)}
                autoResize
            />
        </div>
        {error ?
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{nombre}: {error}</div>
            </div>
            : null}
    </div>;
};
export const PrimeTable = ({ t, edit, nombre, campo, error,fields,selected_campo, ...otherProps }) =>  {
    const [field, , {setValue}] = useField({ name: campo });
    const [selected, , helpersSelected] = useField({ name: selected_campo });
    return <div className="row linea-formulario">
        <div className="col-12 col-md-12 text-md-center">
            <label className='boldie'>{nombre}</label>
        </div>
        <div className="mb-2 col-12 col-md-12 d-block d-flex flex-column">
            <DataTablePrime
                t={t}
                selection={selected.value}
                tableName="tableAgSensors"
                value={field.value} editMode="row"
                onRowEditComplete={(e) => {
                    const _values = [...field.value];
                    const _values_selected = [...selected.value];
                    const { newData, index } = e;
                    _values[index] = newData;
                    const indexSelected = _values_selected?.findIndex((e) => e.key === newData.key);
                    if(indexSelected >=0){
                        _values_selected[indexSelected] = newData;
                        helpersSelected.setValue(_values_selected);
                    }
                    setValue(_values);
                }}
                selectionMode={edit?"checkbox":null} fields={fields}
                onSelectionChange={(e) => helpersSelected.setValue(e.value)} {...otherProps}
            />
        </div>
        {error ?
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{nombre}: {error}</div>
            </div>
            : null}
    </div>;
};

export const PrimeMultiSelect = ({ edit, nombre, dataValue, defaultText, campo, validate, error, showClear,
    options, optionKey, optionLabel, placeholder, onChange,t,errorLbl,valuesPrev, ...extraProps }) => {
    const [field, , { setValue }] = useField({ name: campo, validate });
    const [initialValuesSetted,setInitialValuesSetted] = useState(false);
    const hasOptions = Array.isArray(options) && options.length;
    if (!campo) return null;
    if(valuesPrev && valuesPrev?.[0]?.id && hasOptions && !initialValuesSetted){
        setValue(valuesPrev.map(v =>v.id));
        setInitialValuesSetted(true);
    }
    if (edit && hasOptions) return (
        <div className="row linea-formulario">
            <div className="col-12 col-md-6 text-md-right">
                <label className='boldie capitalize'>{nombre}</label>
            </div>
            <div className="mb-2 col-12 col-md-6 d-block">
                <MultiSelect
                    className="mkt-multiselect"
                    panelClassName='mkt-multiselect-popup'
                    inputId={field.name}
                    placeholder={t("forms.pHolderSelect")}
                    value={field?.value}
                    options={options}
                    optionLabel={optionLabel ?? "label"}
                    optionValue={optionKey ?? "value"}
                    onChange={(e) => {setValue(e.value);onChange && onChange(e.value);}}
                    style={{ color: "#495057", width: showClear?"10vw":"13vw" }}
                    filter
                    filterIcon
                    showSelectAll
                    showClear
                    selectAllLabel={t("forms.selectAll")}
                    selectedItemsLabel={t("forms.itemsSelected",{ total:field.value?.length })}
                    maxSelectedLabels={0}
                    {...extraProps}
                />
            </div>
            {error ?
                <div className="mb-2 col-12 d-block">
                    <div className="alert alert-warning m-0" role="alert">{errorLbl?errorLbl:nombre}: {error}</div>
                </div>
                : null}
        </div>
    );

    const dataToShow = edit ? field.value : dataValue;
    if (!dataToShow && !defaultText) return null;
    let selected = null;
    const thisOption = hasOptions && dataToShow && options.find((option) => option[optionKey] === dataToShow);
    if (thisOption) selected = thisOption[optionLabel] || "";

    return (
        <div className="row linea-formulario">
            <div className="col-12 col-md-6 text-md-right mtem-05">
                <label className='boldie'>{nombre}</label>
            </div>
            <div className="col-12 col-md-6 text-md-left mtem-05">
                <span>{selected || defaultText}</span>
            </div>
        </div>
    );
};
